//  src\pages\Admin\AdminPage.tsx

export const AdminPage = () => {
    return (
        <div className="">
            <h2>Admin Page</h2>
            <p>Administrator Page</p>
        </div>
    )
}

export default AdminPage